export const URL_ENDPOINT_TIEN_TE = `${
  process.env.REACT_APP_ENDPOINT_URL
}/tien-te`;

export const TIEN_TE_PREFIX_URL = "/tien-te";
